import { render, staticRenderFns } from "./WebhookEndpointCreateForm.vue?vue&type=template&id=40c96b86&"
import script from "./WebhookEndpointCreateForm.vue?vue&type=script&lang=js&"
export * from "./WebhookEndpointCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports